export default "__VITE_ASSET__CwMfCtei__"